import { render, staticRenderFns } from "./scroll-header.vue?vue&type=template&id=15ac4c3d&scoped=true&"
import script from "./scroll-header.vue?vue&type=script&lang=js&"
export * from "./scroll-header.vue?vue&type=script&lang=js&"
import style0 from "./scroll-header.vue?vue&type=style&index=0&id=15ac4c3d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ac4c3d",
  null
  
)

export default component.exports